import { Flex, Tag, Tooltip } from '@chakra-ui/react';
import APP_CONSTANTS from '@/utils/constants/app.constants';

const MainFooter = () => (
  <Flex
    color="grey"
    justifyContent="flex-end"
    alignItems="center"
    height="auto"
    fontSize="11px"
    margin="0"
    padding="12px 25px"
    boxShadow="2xl"
  >
    v{import.meta.env.VITE_VERSION} @copyright 2021 Livelinx{' '}
    {APP_CONSTANTS.ENVIRONNEMENT !== 'production' && (
      <Tooltip label={`You are now testing the "${APP_CONSTANTS.ENVIRONNEMENT}" environment`}>
        <Tag colorScheme="red" size="sm" marginLeft="5px" padding="2" paddingY="0">
          {APP_CONSTANTS.ENVIRONNEMENT}
        </Tag>
      </Tooltip>
    )}
  </Flex>
);

export default MainFooter;
